module.exports = __webpack_public_path__ + "img/benefit-05-iot-8.8b076e07.png";